import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DatepickerHeaderComponent, DialogData} from '@vdw/angular-component-library';
import {DateTime} from 'luxon';
import {Observable, Subject} from 'rxjs';

@Component({
  templateUrl: './jump-to-date-picker-calendar.component.html'
})
export class JumpToDatePickerCalendarComponent implements DialogData<DateTime> {
  public selectedDate: DateTime;
  public readonly DATE_PICKER_HEADER = DatepickerHeaderComponent;
  public readonly TODAY = DateTime.now().startOf('day');
  public readonly DEFAULT_DATE = this.TODAY.minus({days: 3});
  private readonly selectedDateSubject = new Subject<DateTime>();

  public constructor(
    @Inject(MAT_DIALOG_DATA) data: {selectedDate: DateTime},
    private readonly dialogRef: MatDialogRef<void>
  ) {
    this.selectedDate = data.selectedDate;
  }

  public applyDate(date: DateTime = this.selectedDate): void {
    this.selectedDateSubject.next(date ?? this.DEFAULT_DATE);
    this.dialogRef.close();
  }

  public getValue(): Observable<DateTime> {
    return this.selectedDateSubject.asObservable();
  }
}
